import { render } from "./StoryOverlay.vue?vue&type=template&id=4d65a522&scoped=true"
import script from "./StoryOverlay.vue?vue&type=script&lang=js"
export * from "./StoryOverlay.vue?vue&type=script&lang=js"

import "./StoryOverlay.vue?vue&type=style&index=0&id=4d65a522&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d65a522"

export default script